<template>
    <div class="contain">
        <img class="imgs" src="../../../assets/c13/acne_01.jpg" />
        <img class="imgs" src="../../../assets/c13/acne_02.jpg" />
        <img class="imgs" src="../../../assets/c13/acne_03.jpg" />
        <img class="imgs" src="../../../assets/c13/acne_04.jpg" />
        <img class="imgs c13_ibtn_cta"  @click="goLink" src="../../../assets/c13/btn_floot_cta.jpg" />
    </div>
</template>

<script>
export default {
    name: 'c13',
    methods: {
        goLink: function()
        {
            window.open('https://tele.soldoc.co.kr/booking?utm_source=mo-5&utm_medium=mo-floating-5&utm_campaign=mo-floating-click-5&utm_content=dr.sol-click-mo-5', '_blank')
        }
    }
}
</script>

<style scoped>
    .contain{
        width: 100%;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        min-width: 800px;
    }
    .c13_ibtn_cta{
        position: fixed;
        bottom: 40px;
        width: 693px;
        height: 96px;
        z-index: 10;
        cursor: pointer;
        box-shadow: 0px 5px 6px rgba(0, 0, 0, 0.15);
        border-radius: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_view/contents/c13.vue